// next
// @mui
import mapIcon from '@iconify/icons-carbon/location-current';
import { Box, Chip, Stack, Tooltip, Typography } from '@mui/material';
import PostBody from '@utils/PostBody';
import staticLoader from '@utils/staticLoader';
import NextImage from "next/image";
// @types
import { JobProps } from 'src/@types/job';
// components
import { BgOverlay, FabButtonAnimate, Iconify } from 'src/components';
//

// ----------------------------------------------------------------------

type Props = {
  job: JobProps;
};

export default function JobDetails({ job }: Props) {
  const { skills, benefits, content } = job;

  return (
    <Stack spacing={5}>
      <PostBody content={content} />

      {/* -- Skills -- */}
      {skills && (
        <section>
          <Typography variant="h4" sx={{ mb: 3 }}>
            Kvalifikasjoner
          </Typography>
          <Stack direction="row" flexWrap="wrap">
            {skills.map((skill) => (
              <Chip key={skill} label={skill} sx={{ m: 0.5 }} onClick={() => { }} />
            ))}
          </Stack>
        </section>
      )}

      {/* -- Other Benefits --- */}
      {benefits && (
        <section>
          <Typography variant="h4" paragraph>
            Vi tilbyr
          </Typography>
          <Box
            component="ul"
            sx={{
              display: 'grid',
              rowGap: 2,
              columnGap: 3,
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
              },
            }}
          >
            {benefits.map((benefit) => (
              <Typography component="li" key={benefit} >{benefit}</Typography>
            ))}
          </Box>
        </section>
      )}

      {/* -- Location Map --- */}
      <section>
        <Typography variant="h4" sx={{ mb: 3 }}>
          Sted
        </Typography>
        <Box sx={{ position: 'relative', borderRadius: 2, overflow: 'hidden' }}>
          <Tooltip title="Åpne lokasjon i Google Maps" placement="right" followCursor>
            <a
              rel="noreferrer"
              target="_blank"
              href='https://www.google.com/maps/place/Bergen+Elektro+Automasjon+AS/@60.2963938,5.3417307,15z/data=!4m5!3m4!1s0x0:0xa0254ac335ab8f26!8m2!3d60.2962449!4d5.3450352'>
              <FabButtonAnimate
                size="large"
                color="inherit"
                sx={{ width: 1, height: 1, bgcolor: "common.white" }}
                sxWrap={{
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  width: 64,
                  height: 64,
                  zIndex: 9,
                  m: 'auto',
                  position: 'absolute',
                }}
              >
                <Iconify icon={mapIcon} sx={{ color: 'primary.main' }} />
              </FabButtonAnimate>
            </a>
          </Tooltip>

          <BgOverlay sx={{ opacity: 0.4, borderRadius: 2 }} />

          <NextImage objectFit="cover" loader={staticLoader} layout="responsive" height="100%" width="100%" alt="map thumbnail" src="/static/images/map.png" />
        </Box>
      </section>
    </Stack>
  );
}
